module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2zm-8.654 20H10.652c-.592 0-.822-.404-.52-.902l5.316-8.724c.302-.498.796-.498 1.1 0l5.318 8.724c.304.498.072.902-.52.902z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/up-square-1.js
// module id = 1477
// module chunks = 14